module.exports = __webpack_public_path__ + "media/services/smart-sales-icon-a5705449.svg";